<template>
  <!--begin::Content wrapper-->
  <div
    :dir="$i18n.locale === 'ar' ? 'rtl' : 'ltr'"
    class="modal fade share-modal-wrapper"
    id="share-modal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalCenterTitle"
    aria-hidden="true"
    @show.modal="hidePaymentModal"
  >
    <div class="modal-dialog modal-md modal-dialog-centered" role="document">
      <div class="modal-content share-modal-content">
        <div class="modal-header share-modal-header">
          <div class="header-title-wrapper">
            <div class="share-icon-wrapper">
              <i class="fas fa-share-alt"></i>
            </div>
            <h5 class="modal-title share-title">
              {{ $t("share.share_via_app") }}
            </h5>
          </div>
          <button type="button" class="close-btn" data-bs-dismiss="modal">
            <i class="fa fa-times"></i>
          </button>
        </div>
        <div class="modal-body share-modal-body">
          <div class="share-content-wrapper" id="share-content"></div>
        </div>
      </div>
    </div>
  </div>
  <!--end::Content wrapper-->

  <div
    :dir="$i18n.locale === 'ar' ? 'rtl' : 'ltr'"
    class="modal fade share-modal-wrapper"
    id="share-web-modal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalCenterTitle"
    aria-hidden="true"
    @show.modal="hidePaymentModal"
  >
    <div class="modal-dialog modal-md modal-dialog-centered" role="document">
      <div class="modal-content share-modal-content">
        <div class="modal-header share-modal-header">
          <div class="header-title-wrapper">
            <div class="share-icon-wrapper web-share">
              <i class="fas fa-globe"></i>
            </div>
            <h5 class="modal-title share-title">
              {{ $t("share.share_on_web") }}
            </h5>
          </div>
          <button type="button" class="close-btn" data-bs-dismiss="modal">
            <i class="fa fa-times"></i>
          </button>
        </div>
        <div class="modal-body share-modal-body">
          <div class="share-content-wrapper" id="share-web-content"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import { apiUrl } from "@/utils/api"; // Adjust the import path according to your project structure

export default {
  name: "VideoClass",
  data() {
    return {
      token: localStorage.getItem("access_token"),
      code: "",
      isLoading: false,
    };
  },
  mounted() {},
  methods: {},
};
</script>

<style scoped>
/* ===== Share Modal Styles ===== */
.share-modal-wrapper .modal-dialog {
  max-width: 450px;
}

.share-modal-content {
  border: none;
  border-radius: 24px;
  overflow: hidden;
  box-shadow: 0 25px 80px rgba(0, 0, 0, 0.15);
}

.share-modal-header {
  background: linear-gradient(135deg, #00c744 0%, #00a83b 100%);
  padding: 20px 25px;
  border: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.header-title-wrapper {
  display: flex;
  align-items: center;
  gap: 15px;
}

.share-icon-wrapper {
  width: 45px;
  height: 45px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(10px);
}

.share-icon-wrapper i {
  color: white;
  font-size: 1.3rem;
}

.share-icon-wrapper.web-share {
  background: rgba(255, 255, 255, 0.25);
}

.share-title {
  color: white;
  font-size: 1.2rem;
  font-weight: 700;
  margin: 0;
}

.close-btn {
  width: 36px;
  height: 36px;
  background: rgba(255, 255, 255, 0.2);
  border: none;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
}

.close-btn i {
  color: white;
  font-size: 1rem;
}

.close-btn:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: rotate(90deg);
}

.share-modal-body {
  padding: 30px 25px;
  background: linear-gradient(135deg, #f8fffe 0%, #e8fff1 100%);
}

.share-content-wrapper {
  text-align: center;
}

/* Dark Mode Support */
[data-bs-theme="dark"] .share-modal-content,
[data-theme="dark"] .share-modal-content,
.dark .share-modal-content {
  background: #1e293b;
}

[data-bs-theme="dark"] .share-modal-body,
[data-theme="dark"] .share-modal-body,
.dark .share-modal-body {
  background: linear-gradient(135deg, #0f172a 0%, #1a2744 100%);
}

[data-bs-theme="dark"] .share-content-wrapper,
[data-theme="dark"] .share-content-wrapper,
.dark .share-content-wrapper {
  color: #f1f5f9;
}
</style>
